<div class="pnl-product">
  <header>
    <a [routerLink]="['/app/estoque']" [class.dnone]="step != 1">Produtos</a>
    <div [class.dnone]="step != 2">
      <button (click)="onBack()" class="btn btn-primary-outline">Voltar</button>
      <button
        (click)="onCancelRegister()"
        [disabled]="product.idproduto_geral == 0"
        class="btn btn-primary-outline"
      >
        Cancelar
      </button>
      <button
        (click)="onSubmit()"
        class="btn btn-primary"
        [disabled]="!changeDetail"
      >
        Salvar
      </button>
    </div>
  </header>
  <section class="pnl pnl-step-one" [class.dnone]="step != 1">
    <i class="ic ic-scanner"></i>

    <h2>Escaneie o código de barras do produto</h2>
    <small>ou digite o código de barras manualmente</small>
    <input
      id="codbarra"
      type="text"
      class="form-control"
      (keyup)="onKeyCodbarra($event)"
      maxlength="19"
      (keyup.enter)="onSearchProduct()"
      mask="0 000000 000000? 000"
    />

    <div class="product-loading">
      <div class="loading" *ngIf="loadingProduct">
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
          <div class="ldio-ns36390yc">
            <div></div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="errorFindCodbar" class="message">
      <h3>
        Não foi possível encontrar um produto cadastrado com o código de barra
        informado!
      </h3>
      <a>Iniciando um cadastro de produto novo...</a>
    </div>
  </section>

  <form [formGroup]="produtoFrm" (ngSubmit)="onSubmit()" novalidate>
    <section
      class="pnl pnl-step-two"
      [class.dnone]="step != 2"
      [class.view]="isView"
    >
      <h3>Cadastro de produto</h3>
      <span class="status">
        <div class="ipt-switch">
          <input
            id="ckStatus"
            formControlName="ckStatus"
            (change)="onChangeDetail()"
            type="checkbox"
            value="S"
            name="status"
          />
          <label for="ckStatus"></label>
        </div>
        <span *ngIf="ckStatus.value">Ativo</span>
        <span *ngIf="!ckStatus.value" class="tred strong">Inativo</span>
      </span>
      <nav>
        <a
          (click)="onTabClick('informacoes')"
          [class.active]="tab == 'informacoes'"
          >Informações</a
        >
        <a (click)="onTabClick('preco')" [class.active]="tab == 'preco'"
          >Preço</a
        >
        <a (click)="onTabClick('estoque')" [class.active]="tab == 'estoque'"
          >Estoque</a
        >
        <a (click)="onTabClick('codbarra')" [class.active]="tab == 'codbarra'"
          >Código de barras</a
        >
      </nav>
      <div class="tab-informacoes" [class.dnone]="tab != 'informacoes'">
        <div>
          <div class="pnl-departament">
            <strong>Departamentos</strong>
            <div formArrayName="categories">
              <div
                *ngFor="let category of categories.controls; let i = index"
                [formGroupName]="i"
                class="row"
              >
                <label>Categoria do produto</label>
                <div class="col">
                  <ng-select
                    *ngIf="
                      categorias.length > 0 &&
                      category.controls.showText.value == false
                    "
                    class="ng-select-visible ng-categoria"
                    formControlName="categoria"
                    [items]="categorias"
                    placeholder="Selecione uma categoria"
                    (change)="onChangeCategoria(category, i)"
                    (clear)="onChangeDepartamento()"
                    bindLabel="ds_categoria"
                    bindValue="idcategoria"
                  ></ng-select>

                  <input
                    *ngIf="
                      categorias.length == 0 ||
                      category.controls.showText.value == true
                    "
                    type="text"
                    class="form-control"
                    placeholder="Preencha com a nova categoria"
                    (keyup)="onChangeDepartamento()"
                    formControlName="categoria"
                  />
                  <button
                    *ngIf="
                      categorias.length > 0 &&
                      category.controls.showText.value == false &&
                      category.controls.categoria.value == null
                    "
                    (click)="newCategory(category)"
                    type="button"
                    class="btn btn-warning-outline"
                  >
                    nova
                  </button>
                  <button
                    *ngIf="
                      categorias.length > 0 &&
                      category.controls.showText.value == true
                    "
                    (click)="newCategory(category)"
                    type="button"
                    class="btn btn-warning-outline"
                  >
                    selecionar
                  </button>

                  <button
                    (click)="removeCategoria(i)"
                    *ngIf="categories.controls.length > 1"
                    type="button"
                    class="btn btn-danger-outline"
                  >
                    remover
                  </button>
                </div>
                <div
                  class="pnl-subcategoria"
                  *ngIf="
                    category.controls.subcategorias &&
                    category.controls.subcategorias.controls.length > 0
                  "
                >
                  <div class="row">
                    <label class="mb15m">Subcategoria do produto</label>
                    <app-subcategoria-item
                      [id]="i"
                      [list]="category.controls.list.value"
                      [subcategorias]="category.controls.subcategorias"
                      (onChangeEvent)="onChangeDepartamento()"
                    ></app-subcategoria-item>
                  </div>
                  <!--<button (click)="addNewSubcategory(category.controls.subcategories)" type="button" class="btn btn-primary-outline">Adicionar subcategoria</button>-->
                </div>
                <div class="pnl-subcategoria">
                  <div class="row">
                    <div class="item-subcategoria">
                      <div class="row mt15">
                        <div class="col">
                          <button
                            (click)="
                              addNewSubcategory(category.controls.subcategorias)
                            "
                            type="button"
                            class="btn btn-primary-outline btn-new-subcategoria"
                          >
                            Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              (click)="addNewCategory()"
              type="button"
              class="btn btn-primary"
            >
              Adicionar categoria
            </button>
          </div>

          <label>Marca</label>
          <input
            type="text"
            class="form-control"
            (keyup)="onChangeDetail()"
            formControlName="marca"
          />
          <strong class="view">{{ product.marca }}</strong>

          <label>Embalagem do produto</label>
          <ng-select
            [items]="embalagens"
            formControlName="embalagem"
            bindLabel="embalagem"
            (change)="onChangeDetail()"
            (clear)="onChangeDetail()"
            bindValue="embalagem"
          ></ng-select>
          <strong class="view">{{ product.embalagem }}</strong>

          <label>Peso do produto</label>
          <div class="peso">
            <input
              type="text"
              class="form-control"
              formControlName="peso_liquido"
              (keyup)="onChangeDetail()"
              currencyMask
              placeholder="0"
            /><span
              ><ng-select
                [items]="unidades"
                (change)="onChangeDetail()"
                (clear)="onChangeDetail()"
                formControlName="unidade_peso_liquido"
                placeholder="Selecione"
                bindLabel="label"
                bindValue="unidade"
              ></ng-select
            ></span>
          </div>
          <strong class="view"
            >{{ product.peso_liquido
            }}{{ product.unidade_peso_liquido }}</strong
          >

          <label>Nome sugerido ao produto</label>
          <input
            type="text"
            class="form-control form-descricao"
            formControlName="descricao"
            (keyup)="onChangeDetail()"
            placeholder="Nome..."
          />

          <label>Subtítulo do produto</label>
          <input
            type="text"
            class="form-control form-descricao"
            formControlName="subtitulo"
            (keyup)="onChangeDetail()"
            maxlength="40"
            placeholder="Subtítulo..."
          />

          <a
            (click)="toogleDescribe()"
            class="link-descricao"
            [class.open]="describeVisible"
            >Descrição do produto <span>(opcional)</span></a
          >
        </div>
        <div>
          <ul
            *ngIf="
              (uploader.queue && uploader.queue.length > 0) ||
              (gallery && gallery.length > 0)
            "
            class="galery-queue"
          >
            <li
              *ngFor="let image of gallery; let i = index"
              (click)="selectPhoto(image, i)"
              [class.active]="i == fileImageIdx"
            >
              <img [src]="ajustUrl(image.small + '?' + image.hash)" />
            </li>
            <li
              *ngFor="let item of uploader.queue; let i = index"
              (click)="selectImageView(item, i)"
              [class.active]="i == fileViewIdx"
            >
              <img src="" imgPreview [image]="item?._file" class="c-object" />
            </li>
            <li
              (click)="addMoreImage()"
              *ngIf="
                uploader.queue &&
                uploader.queue.length + gallery.length < 5 &&
                gallery.length < 5
              "
            >
              <i class="ic ic-no-image-small"></i>
            </li>
          </ul>

          <div *ngIf="isFileView || isImageView" class="media-view">
            <figure>
              <img
                *ngIf="isFileView && fileView"
                src=""
                imgPreview
                [image]="fileView?._file"
                class="media-object"
              />
              <img
                *ngIf="isImageView && image_sel_src"
                [src]="ajustUrl(image_sel_src + '?' + image_sel_hash)"
              />
            </figure>
            <div class="subtitle">
              <input
                type="text"
                class="form-control"
                formControlName="image_subtitle"
                (keyup)="onChangeSubtitle()"
                placeholder="Legenda..."
              />
            </div>
            <div *ngIf="isFileView" class="actions">
              <button
                type="button"
                (click)="onRemoveFileImage(); fileUploader.click()"
                class="btn btn-warning"
              >
                TROCAR IMAGEM
              </button>
              <button
                type="button"
                (click)="onRemoveFileImage()"
                class="btn btn-danger"
              >
                EXCLUIR IMAGEM
              </button>
            </div>
            <div *ngIf="isImageView" class="actions">
              <button
                type="button"
                *ngIf="isImageChange"
                (click)="onChangeImage()"
                class="btn btn-warning"
              >
                TROCAR IMAGEM
              </button>
              <button
                type="button"
                (click)="onRemoveImage()"
                class="btn btn-danger"
              >
                EXCLUIR IMAGEM
              </button>
            </div>
          </div>

          <div
            *ngIf="!isFileView && !isImageView"
            ng2FileDrop
            [uploader]="uploader"
            (fileOver)="fileOverBase($event)"
            class="region-upload"
            [ngClass]="{
              'nv-file-over': hasBaseDropZoneOver,
              'nv-has-galery': gallery.length > 0
            }"
          >
            <i class="ic ic-no-image"></i>
            <strong
              >Arraste e solte aqui até
              {{ 5 - numberPhoto - uploader.queue.length }}
              {{
                5 - numberPhoto - uploader.queue.length > 1 ? "fotos" : "foto"
              }}
              do produto</strong
            >
            <button
              type="button"
              (click)="fileUploader.click()"
              class="btn btn-primary-outline"
            >
              ou clique aqui para buscar
            </button>
          </div>

          <input
            id="fileUploader"
            #fileUploader
            type="file"
            ng2FileSelect
            [uploader]="uploader"
            class="dnone"
            multiple
          />

          <div class="origem">
            <strong>Origem do produto</strong>
            <div>
              <div>
                <label>Fabricação do produto</label>
                <ng-select
                  [items]="fabricacao_select"
                  formControlName="fabricacao"
                  (change)="onChangeDetail()"
                  (clear)="onChangeDetail()"
                  placeholder="Selecione"
                  bindLabel="text"
                  bindValue="value"
                ></ng-select>
                <strong class="view">Industrializado</strong>
              </div>
              <div>
                <mat-checkbox
                  id="ckImportado"
                  (change)="onChangeDetail()"
                  formControlName="importado"
                  >Produto importado</mat-checkbox
                >
                <label
                  for="ck-importado"
                  class="ck-importado view"
                  [class.dnone]="!importado.value"
                  >Produto importado</label
                >
              </div>
            </div>
          </div>

          <div class="keywords">
            <label>Keywords para busca</label>
            <textarea
              class="form-control"
              formControlName="keywords"
              (keyup)="onChangeDetail()"
              rows="3"
            ></textarea>

            <label>Relevância na busca</label>
            <input
              type="text"
              class="form-control form-descricao"
              formControlName="relevancia"
              currencyMask
              [options]="{ precision: 0, allowNegative: false }"
              (keyup)="onChangeDetail()"
              placeholder="Relevância..."
            />

            <label>Código interno</label>
            <input
              type="text"
              class="form-control form-descricao"
              formControlName="codigo_interno"
              currencyMask
              [options]="{ precision: 0, allowNegative: false, thousands: '' }"
              (keyup)="onChangeDetail()"
              placeholder="código interno do produto no estabelecimento"
            />
          </div>

          <div *ngIf="isWine" class="vivino-codes">
            <div>
              <div>
                <label>Código Vivino do produto</label>
                <input
                  type="text"
                  class="form-control form-descricao"
                  (keyup)="onChangeDetail()"
                  currencyMask
                  [options]="{ precision: 0, allowNegative: false }"
                  formControlName="vivino_code"
                />
              </div>
              <div>
                <label>Código Vivino da safra</label>
                <input
                  type="text"
                  class="form-control form-descricao"
                  (keyup)="onChangeDetail()"
                  currencyMask
                  [options]="{ precision: 0, allowNegative: false }"
                  formControlName="vivino_safra"
                />
              </div>
            </div>
          </div>

          <div class="keywords">
            <mat-checkbox
              id="ckAmadurecimento"
              (change)="onChangeDetail()"
              formControlName="ckAmadurecimento"
              class="ck-amadurecimento"
              >Permitir a seleção do ponto de amadurecimento</mat-checkbox
            >

            <mat-checkbox
              id="ckRefrigerado"
              (change)="onChangeDetail()"
              formControlName="refrigerado"
              class="ck-amadurecimento"
              >Produto refrigerado</mat-checkbox
            >
          </div>
        </div>
      </div>

      <div
        class="descricao"
        [class.dnone]="tab != 'informacoes' || !describeVisible"
      >
        <quill-editor
          formControlName="detalhe"
          (keyup)="onChangeDetail()"
          class="text-descricao"
        >
        </quill-editor>
      </div>

      <div class="tab-preco" [class.dnone]="tab != 'preco'">
        <div class="valor">
          <div>
            <label>Preço original do produto</label>
            <div class="valor-input">
              <input
                type="text"
                class="form-control"
                (keyup)="onChangePrice()"
                formControlName="preco"
                currencyMask
                placeholder="R$ 0,00"
              /><span
                ><ng-select
                  [items]="formas_de_venda"
                  (change)="onChangeDetail()"
                  (clear)="onChangeDetail()"
                  formControlName="forma_venda"
                  placeholder="Selecione"
                  bindLabel="label"
                  bindValue="unidade"
                ></ng-select
              ></span>
            </div>
          </div>
          <div class="fdc"></div>
        </div>

        <div class="valor" *ngIf="forma_venda.value != 'U'">
          <div>
            <label>Forma de seleção do produto no site</label>
            <ng-select
              [items]="formas_de_venda_mostra"
              (change)="onChangeDetail()"
              (clear)="onChangeDetail()"
              formControlName="forma_venda_mostra"
              placeholder="Selecione"
              bindLabel="label"
              bindValue="unidade"
            ></ng-select>
          </div>
          <div class="fdc"></div>
        </div>

        <div class="limite">
          <div>
            <label>Limite de compra por cliente</label>
            <input
              type="text"
              formControlName="max_pr_cliente"
              (keyup)="onChangeDetail()"
              currencyMask
              [options]="{ precision: 0, allowNegative: false }"
              class="form-control"
            />
          </div>
          <div class="fdc">
            <mat-checkbox
              id="ckFrete"
              (change)="onChangeDetail()"
              formControlName="ckFrete"
              class="asfs"
              [class.ck-promocao]="ckFrete.value"
              >Frete grátis</mat-checkbox
            >
          </div>
        </div>

        <div
          class="promocao"
          [class.dnone]="product.idproduto_estabelecimento == 0"
        >
          <app-product-offers #productOffersItem></app-product-offers>
        </div>

        <div class="config" *ngIf="isAdmin">
          <div>
            <mat-checkbox
              id="ckChangePrice"
              (change)="onChangeDetail()"
              formControlName="ckChangePrice"
              class="asfs"
              [class.ck-promocao]="ckChangePrice.value"
              >Permitir o ajuste do preço pelo APP Retaguarda!</mat-checkbox
            >
          </div>
        </div>
      </div>

      <div class="tab-estoque" [class.dnone]="tab != 'estoque'">
        <div>
          <div>
            <label>Quantidade em estoque</label>
            <div class="form-w-check">
              <input
                type="text"
                class="form-control"
                placeholder="0"
                formControlName="estoque"
                [attr.disabled]="sem_limite.value ? true : null"
                (keyup)="onChangeDetail()"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
              />
              <mat-checkbox
                formControlName="sem_limite"
                (change)="onUnlimitedStock()"
                >Sem limite de estoque</mat-checkbox
              >
            </div>
          </div>
          <div *ngIf="!sem_limite.value" class="frm fdc">
            <label>Limite mínimo do estoque</label>
            <input
              type="text"
              formControlName="limite_minimo_estoque"
              (keyup)="onChangeDetail()"
              currencyMask
              [options]="{ precision: 0, allowNegative: false }"
              class="form-control"
            />
          </div>
        </div>
        <div></div>
      </div>

      <div class="tab-codbarra" [class.dnone]="tab != 'codbarra'">
        <div>
          <label>Linha digitável</label>
          <input
            *ngIf="product.idproduto_geral == 0"
            type="text"
            class="form-control dnone"
            (keyup)="onChangeCodBarra()"
            formControlName="codbarra"
            mask="0 000000 000000? 00000 0"
            placeholder="0 000000 000000"
          />
          <strong class="view view-codbarra">{{
            this.codbarra.value | mask: "0 000000 000000? 00000 0"
          }}</strong>
          <div>
            <ngx-barcode6
              [bc-format]="'EAN13'"
              [bc-value]="this.codbarra.value"
              [bc-display-value]="true"
            >
            </ngx-barcode6>
          </div>
        </div>

        <div></div>
      </div>
    </section>
  </form>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
      <div class="ldio-ns36390yc">
        <div></div>
      </div>
    </div>
  </div>
</div>
